if (!window.ProductComponent) {
  class ProductComponent extends HTMLElement {
    constructor () {
      super()
      this.subscriptionSelected = true
      this.initializeElements()
      this.loadProductData()
      this.setupEventListeners()
    }

    connectedCallback () {
      this.syncSubscriptionStateFromDOM()
      this.filterPlansForVariant()
      this.updatePlan()
      this.updatePrices()
    }

    syncSubscriptionStateFromDOM () {
      if (!this.subscriptionToggleAll?.length) return

      if (this.subscriptionToggleAll.length > 1) {
        const activeToggle = Array.from(this.subscriptionToggleAll).find(
          tgl => tgl.classList.contains('is-Active'),
        ) || this.subscriptionToggleAll[0]

        this.subscriptionSelected = activeToggle.value === 'subscribe'
        this.subscriptionToggleAll.forEach(tgl => {
          const isActive = tgl === activeToggle
          tgl.classList.toggle('is-Active', isActive)
          tgl.querySelector('.sb-Price')?.classList.toggle('is-Active', isActive)
        })
      } else {
        const toggle = this.subscriptionToggleAll[0]
        this.subscriptionSelected = toggle.classList.contains('is-Active')
      }

      this.subscriptionOptionsEl?.classList.toggle('is-Active', this.subscriptionSelected)
    }

    initializeElements () {
      // Add to cart
      this.form = this.querySelector(`[data-product-form][data-id="${this.dataset.id}"]`)
      this.variantInput = this.form?.querySelector('input[name="id"]')
      this.cartPriceEl = this.querySelectorAll(`[data-cart-price][data-id="${this.dataset.id}"]`)
      this.cartPriceCompareEl = this.querySelectorAll(`[data-cart-price-compare][data-id="${this.dataset.id}"]`)

      // Variant picker elements
      this.optionButtons = this.querySelectorAll(`[data-product-option][data-id="${this.dataset.id}"]`)
      this.optionSelects = this.querySelectorAll(`[data-product-option-select][data-id="${this.dataset.id}"]`)

      // Subscription elements
      this.subscriptionWidget = this.querySelector(`[data-subscription-widget][data-id="${this.dataset.id}"]`)
      this.planInput = this.form?.querySelector('[name="selling_plan"]')
      this.onetimePriceAll = this.subscriptionWidget?.querySelectorAll('[data-onetime-price]')
      this.subscriptionPriceAll = this.subscriptionWidget?.querySelectorAll('[data-subscription-price]')
      this.planSelectEl = this.subscriptionWidget?.querySelector('[data-plan-select]')
      this.subscriptionToggleAll = this.subscriptionWidget?.querySelectorAll('[data-subscription-toggle]')
      this.subscriptionOptionsEl = this.subscriptionWidget?.querySelector('[data-subscription-options]')

      if (this.planSelectEl) {
        this.planId = parseInt(this.planSelectEl.value)
      }

      if (!this.form) {
        throw new Error(`product-component.js: Product form not found, id: ${this.dataset.id}`)
      }
    }

    loadProductData () {
      const productJsonEl = this.querySelector(`[data-product-json][data-id="${this.dataset.id}"]`)

      if (!productJsonEl) {
        throw new Error(`product-component.js: Product data not found, id: ${this.dataset.id}`)
      }

      // console.log("yagi hey");
      // console.debug(productJsonEl.textContent);
      this.productJson = productJsonEl ? JSON.parse(productJsonEl.textContent) : null
      this.variantsJson = this.productJson?.product?.variants || []
      this.currentVariant = this.productJson?.currentVariant || this.variantsJson[0]
    }

    setupEventListeners () {
      // Variant picker events
      this.optionButtons?.forEach(button => {
        button.addEventListener('click', () => this.handleOptionChange(button))
      })
      this.optionSelects?.forEach(select => {
        select.addEventListener('change', () => this.handleOptionChange(select))
      })

      // Subscription events
      this.subscriptionToggleAll?.forEach(toggle => {
        toggle.addEventListener('click', () => this.handleSubscriptionToggleClick(toggle))
      })
      this.planSelectEl?.addEventListener('change', () => this.handlePlanSelectChange())
    }

    handleSubscriptionToggleClick (toggle) {
      if (this.subscriptionToggleAll.length > 1) {
        this.subscriptionSelected = toggle.value === 'subscribe'
        this.subscriptionToggleAll?.forEach(tgl => {
          tgl.classList.remove('is-Active')
          tgl.querySelector('.sb-Price')?.classList.remove('is-Active')
        })
        toggle.classList.add('is-Active')
        toggle.querySelector('.sb-Price')?.classList.add('is-Active')
      } else {
        this.subscriptionSelected = !this.subscriptionSelected
        toggle.classList.toggle('is-Active', this.subscriptionSelected)
        toggle.querySelector('.sb-Price')?.classList.toggle('is-Active', this.subscriptionSelected)
      }
      this.subscriptionOptionsEl?.classList.toggle('is-Active', this.subscriptionSelected)
      this.updatePlan()
      this.updatePrices()
    }

    updatePlan () {
      if (!this.planInput) return
      if (this.subscriptionSelected && this.planId) {
        this.planInput.value = this.planId
        this.planInput.disabled = false
        this.planInput.name = 'selling_plan'
      } else {
        this.planInput.value = ''
        this.planInput.disabled = true
        this.planInput.removeAttribute('name')
      }
    }

    handleOptionChange (element) {
      // Deselect other buttons in same option group
      const option = element.dataset.option

      this.optionButtons.forEach(otherButton => {
        if (otherButton.dataset.option === option) {
          if (otherButton.value === element.value) {
            otherButton.classList.add('is-Active')
          } else {
            otherButton.classList.remove('is-Active')
          }
        }
      })

      this.optionSelects.forEach(otherSelect => {
        if (otherSelect.dataset.option === option) {
          otherSelect.value = element.value
        }
      })
      this.updateVariant()
    }

    handlePlanSelectChange () {
      if (!this.planSelectEl) return

      this.planId = parseInt(this.planSelectEl.value)
      this.updatePrices()
      this.updatePlan()
    }

    updateVariant () {
      const selectedOptions = {}

      this.optionButtons.forEach(button => {
        if (button.classList.contains('is-Active')) {
          selectedOptions[button.dataset.option] = button.value
        }
      })

      this.optionSelects.forEach(select => {
        if (select.value) {
          selectedOptions[select.dataset.option] = select.value
        }
      })

      const matchedVariant = this.variantsJson.find(variant => {
        return Object.entries(selectedOptions).every(([option, value]) =>
          variant[`option${Object.keys(selectedOptions).indexOf(option) + 1}`] === value,
        )
      })

      if (matchedVariant) {
        this.variantChangeCallback({ variant: matchedVariant })
        this.updateURL()
        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.variantChange, { variant: matchedVariant, id: this.dataset.id })
        }
      }
    }

    variantChangeCallback (data) {
      if (!data.variant) return

      this.currentVariant = data.variant
      this.variantInput.value = data.variant.id
      this.filterPlansForVariant()
      this.updatePlan()
      this.updatePrices()
    }

    // The dropdown lists every plan of the product, but each variant only accepts its own
    // (Sun Gummies: the 90-day plan is only for 90 Servings). Show only the current variant's plans
    // and move the selection if it does not apply.
    filterPlansForVariant () {
      if (!this.planSelectEl || !this.currentVariant?.selling_plan_allocations) return

      const allowed = this.currentVariant.selling_plan_allocations.map(allocation => String(allocation.selling_plan_id))
      Array.from(this.planSelectEl.options).forEach(option => {
        option.disabled = !allowed.includes(option.value)
      })
      this.subscriptionWidget?.querySelectorAll('[data-select-option]').forEach(option => {
        option.style.display = allowed.includes(option.dataset.value) ? '' : 'none'
      })

      if (allowed.includes(String(this.planId))) return
      const firstAllowed = Array.from(this.planSelectEl.options).find(option => !option.disabled)
      if (!firstAllowed) return
      this.planSelectEl.value = firstAllowed.value
      this.planId = parseInt(firstAllowed.value)
      const valueEl = this.subscriptionWidget?.querySelector('[data-select-value]')
      if (valueEl) valueEl.textContent = firstAllowed.textContent
    }

    getPrice (variant, usePlanPrice = false) {
      if (!variant) return ''

      var variant_price = variant.price;
      if(variant.discount_percentage && variant.discount_percentage > 0.01){
        variant_price = variant.price * (1.0 - variant.discount_percentage);
      }

      if (!usePlanPrice) return variant_price

      const allocation = variant.selling_plan_allocations?.find(
        allocation => allocation.selling_plan_id === this.planId,
      )
      return allocation ? allocation.price : variant_price
    }

    updatePrices () {
      if (!this.currentVariant) return

      console.log("current variant update price");
      console.debug(this.currentVariant.id);

      this.onetimePriceAll?.forEach(price => {
        price.textContent = formatPrice(this.getPrice(this.currentVariant))
      })
      this.subscriptionPriceAll?.forEach(price => {
        price.textContent = formatPrice(this.getPrice(this.currentVariant, true))
      })

      // go through both one time price and subscription price at the same time
      if(this.onetimePriceAll && this.subscriptionPriceAll) {
        if(this.onetimePriceAll.length == this.subscriptionPriceAll.length){
          for (let i = 0; i < this.onetimePriceAll.length; i++) {
              const currentOnetimePrice = this.getPrice(this.currentVariant);
              const currentSubscriptionPrice = this.getPrice(this.currentVariant, true);

              if(currentSubscriptionPrice && currentSubscriptionPrice >= currentOnetimePrice){
                this.onetimePriceAll[i].textContent = "";
              }
          }
        }
      }

      // Update cart price
      this.cartPriceEl.forEach(price => {
        price.textContent = this.subscriptionSelected
          ? formatPrice(this.getPrice(this.currentVariant, true))
          : formatPrice(this.getPrice(this.currentVariant))
      })

      // Update cart price compare
      var variant_price = this.currentVariant.price;
      var variant_compare_at_price = this.currentVariant.compare_at_price;
      if(this.currentVariant.discount_percentage > 0.01){
        variant_price = this.currentVariant.price * (1.0 - this.currentVariant.discount_percentage);
        variant_compare_at_price = this.currentVariant.price;
        if(this.currentVariant.compare_at_price > variant_compare_at_price && false){
          variant_compare_at_price = this.currentVariant.compare_at_price;
        }
      }

      this.cartPriceCompareEl?.forEach(price => {
        console.log("cart price compare el");
        console.debug(this.currentVariant);
        if (this.subscriptionSelected) {
          price.textContent = formatPrice(this.getPrice(this.currentVariant))
          const otPrice = this.getPrice(this.currentVariant);
          const subPrice = this.getPrice(this.currentVariant, true);

          if(subPrice < otPrice){
            price.classList.remove('is-Hidden');
          } else {
            price.classList.add('is-Hidden');
          }
        } else if (variant_compare_at_price > variant_price) {
          price.textContent = formatPrice(variant_compare_at_price)
          price.classList.remove('is-Hidden')
        } else {
          price.classList.add('is-Hidden')
        }
      })
    }

    updateURL () {
      if (!this.dataset.urlChange || this.dataset.historyUpdateDisabled || !window.history?.replaceState) return

      const url = new URL(window.location)
      const params = new URLSearchParams(url.search)

      params.set('variant', this.currentVariant.id)
      url.search = params.toString()

      window.history.replaceState({ path: url.toString() }, '', url.toString())
    }
  }

  // Create a mixin for ProductCard behaviors
  const ProductCardBehavior = (Base) => class extends Base {
    constructor () {
      super()
      this.opener = this.querySelector('[data-opener]')
    }

    connectedCallback () {
      super.connectedCallback && super.connectedCallback()
      if (this.dataset.hasPlans === 'true') {
        this.form.addEventListener('click', (e) => {
          console.log('----- clicked')
          if (!this.classList.contains('is-Active')) {
            e.preventDefault()
            this.classList.add('is-Active')
            return false
          } else {
            this.classList.remove('is-Active')
          }
        })
      }
    }
  }

  // Create a mixin for Bundle behaviors
  const BundleBehavior = (Base) => class extends Base {
    constructor () {
      super()
    }

    connectedCallback () {
      super.connectedCallback()
    }

    initializeElements () {
      super.initializeElements && super.initializeElements()
      this.planInput1 = this.form?.querySelector('[name="items[0][selling_plan]"]')
      this.planInput2 = this.form?.querySelector('[name="items[1][selling_plan]"]')
    }

    updatePlan () {
      if (!this.planInput1 || !this.planInput2) return
      if (this.subscriptionSelected && this.planId) {
        this.planInput1.value = this.planId
        this.planInput2.value = this.planId
        this.planInput1.disabled = false
        this.planInput2.disabled = false
        this.planInput1.name = 'items[0][selling_plan]'
        this.planInput2.name = 'items[1][selling_plan]'
      } else {
        this.planInput1.value = ''
        this.planInput2.value = ''
        this.planInput1.disabled = true
        this.planInput2.disabled = true
        this.planInput1.removeAttribute('name')
        this.planInput2.removeAttribute('name')
      }
    }
  }

  // Simplified ProductCard using the mixin
  class ProductCard extends ProductCardBehavior(ProductComponent) {
    // No additional methods needed - behaviors come from the mixin
  }

  // Simplified BundleComponent using the mixin
  class BundleComponent extends BundleBehavior(ProductComponent) {
    // No additional methods needed - behaviors come from the mixin
  }

  // Combined component using both mixins
  class BundleProductCard extends ProductCardBehavior(BundleBehavior(ProductComponent)) {
    // Gets all behavior from both mixins and the base component
  }

  if (!customElements.get('product-component')) {
    customElements.define('product-component', ProductComponent)
  }

  if (!customElements.get('product-card')) {
    customElements.define('product-card', ProductCard)
  }

  if (!customElements.get('bundle-component')) {
    customElements.define('bundle-component', BundleComponent)
  }

  if (!customElements.get('bundle-product-card')) {
    customElements.define('bundle-product-card', BundleProductCard)
  }
}
